define([
    'prop-types',
    'santaProps/utils/propsSelectorsUtils',
    'santaProps/utils/dataFetchUtil'
], function (
    PropTypes,
    propsSelectorsUtils,
    dataFetchUtil
) {
    'use strict';

    const createGlobalSantaType = propsSelectorsUtils.createGlobalSantaType;

    const staticMediaUrl = createGlobalSantaType(PropTypes.string, function (state) {
        return state.siteData.getStaticMediaUrl();
    }, 'staticMediaUrl');

    const staticVideoUrl = createGlobalSantaType(PropTypes.string, function (state) {
        return state.siteData.getStaticVideoUrl();
    }, 'staticVideoUrl');

    const adaptiveVideoDomain = createGlobalSantaType(PropTypes.string, function (state) {
        return state.siteData.getAdaptiveVideoDomain();
    }, 'adaptiveVideoDomain');

    const staticHTMLComponentUrl = createGlobalSantaType(PropTypes.string, function (state) {
        return state.siteData.getStaticHTMLComponentUrl();
    }, 'staticHTMLComponentUrl');

    const getMediaFullStaticUrl = createGlobalSantaType(PropTypes.func, function (state) {
        return state.siteData.getMediaFullStaticUrl; // already bound to siteData
    }, 'getMediaFullStaticUrl');

    const serviceTopology = createGlobalSantaType(PropTypes.object, function (state) {
        return dataFetchUtil.get(state, 'serviceTopology');
    }, 'serviceTopology');

    return {
        staticMediaUrl,
        staticVideoUrl,
        adaptiveVideoDomain,
        getMediaFullStaticUrl,
        serviceTopology,
        getStaticHTMLComponentUrl: staticHTMLComponentUrl,
        staticHTMLComponentUrl
    };
});
